<template>
  <div class="payment_bank">
    <!-- <v-row v-if="loadFirm">
      <v-col class="text-center">
        <Loading class="accents" />
        <h3>Проверка агентской информации по Вашей фирме</h3>
      </v-col>
    </v-row>
    <v-row v-if='checkNeedData()'>
      <v-col class="text-center"
        >Данные по фирме получены.
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col class="text-center"
        >Данные по фирме получены. Можно продолжить!
      </v-col>
    </v-row> -->
    <v-row>
      <v-col>
        <MainOrgInfo :likeComponent="true" @valid="setValid($event)" @organization="setOrg($event)" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Rules from "@/components/api/rules.js";
import MainOrgInfo from "@/views/orginfo/orgMainInfo.vue";
export default {
  name: "payment_bank",
  components: {
    // Loading,
    MainOrgInfo,
  },
  data: () => ({
    loadFirm: true,
    firmData: {
      inn: "",
      kpp: "",
      orgShortName: "",
      jurrAddr: "",
    },
    showKPP: true,
    Rules,
  }),
  methods: {
    setOrg(ev) {
      this.firmData = Object.assign({}, ev);
      this.$store.commit("SET_ORGANIZATION_AGENT", Object.assign({}, ev));
    },
    setValid(ev) {
      this.$emit("setValid", { step: 2, valid: ev });
    },
    // checkNeedData() {
    //   const firmData = this.$store.getters.getOrganisationAgent
    //   if(this.showKPP){
    //     return firmData.inn &&
    //     firmData.kpp &&
    //     firmData.orgShortName &&
    //     firmData.jurrAddr ? false : true
    //   }else{
    //     return firmData.inn &&
    //     firmData.orgShortName &&
    //     firmData.jurrAddr ? false : true
    //   }
    // },
    // async checkFirmInfo() {
    //   const { data } = await this.$store.dispatch("getAgentFirm");
    //   if( data.userFirm.JurIPSam == 'SZ'){
    //     this.$emit('showKPP',false)
    //     this.showKPP = false
    //   }
    //   this.firmData = data.userFirm;
    //   this.loadFirm = false;
    // },
    // onPasteFromClipboard() {
    //   this.firmData.inn = String(this.firmData.inn).replace(
    //     /(\r\n|\n|\r|\s|\s+)/g,
    //     ""
    //   );
    // },
    // OnChangeINN() {
    //   this.$store
    //     .dispatch("FillByINN", { inn: this.firmData.inn })
    //     .then((res) => {
    //       if (res.status_api === "gosebase") {
    //         const data = res.data.main.data;
    //         this.firmData.kpp = data.kpp;
    //         this.firmData.orgShortName =
    //           data.name && data.name.short_with_opf
    //             ? data.name.short_with_opf
    //             : "";
    //         this.firmData.jurrAddr =
    //           data.address && data.address.unrestricted_value
    //             ? data.address.unrestricted_value
    //             : "";
    //       } else if (res.status_api === "dadata") {
    //         const data = res.data[0];
    //         this.firmData.kpp = data.kpp;
    //         this.firmData.orgShortName = data.name;
    //         this.firmData.jurrAddr = data.address;
    //       }
    //       this.$store.dispatch("SET_ORGANIZATION_AGENT_PARAM", {
    //         param: "inn",
    //         value: this.firmData.inn,
    //       });
    //       this.$store.dispatch("SET_ORGANIZATION_AGENT_PARAM", {
    //         param: "kpp",
    //         value: this.firmData.kpp,
    //       });
    //       this.$store.dispatch("SET_ORGANIZATION_AGENT_PARAM", {
    //         param: "orgShortName",
    //         value: this.firmData.orgShortName,
    //       });
    //       this.$store.dispatch("SET_ORGANIZATION_AGENT_PARAM", {
    //         param: "jurrAddr",
    //         value: this.firmData.jurrAddr,
    //       });
    //     });
    // },
  },
  mounted() {
    // this.checkFirmInfo();
  },
};
</script>
<style lang="sass" scoped>
</style>
